export const PASSWORD_COMPROMISED_DENIED = -13;
export const PASSWORD_COMPROMISED = -12;
export const EMPLOYEE_NOT_FOUND = -11;
export const OLD_PASSWORD_DOES_NOT_MATCH = -10;
export const REUSE_CURRENT_PASSWORD = -9;
export const BIRTH_DATE_DOES_NOT_MATCH = -8;
export const PASSWORD_ALREADY_INITIALIZED = -7;
export const USER_LOCKED = -6;
export const REUSED_PASSWORD = -5;
export const CODE_EXPIRED = -4;
export const EXCEEDED_MAX_ATTEMPS = -3;
export const NOT_VALID = -2;
export const CODE_ALREADY_EXISTS = -1;
export const OK = 0;